import Vue from 'vue';
import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload, {
    preLoad: 1.5,
    attempt: 1,
    lazyComponent: true,
    listenEvents: ['scroll'],
});
